
  import { Vue, Component, Watch } from "vue-property-decorator";
  import { RESET_SCROLL, RESTORE_SCROLL, SAVE_SCROLL } from "@/entities/Events";

  @Component({})
  export default class ContentScrollManager extends Vue {
    previousScrollPosition = 0;

    @Watch('$route', { deep: true })
    onUrlChange() {
      // const scrollToTop = this.$route.query?.scroll || '1'
      // if(scrollToTop === '0')
      //     return ;
      // this.resetScrollPosition();
    }

    get container(): HTMLDivElement {
      return this.$refs.contentWrapper as HTMLDivElement;
    }

    created() {
      this.$eventBus.listen(SAVE_SCROLL, this.saveScrollPosition);
      this.$eventBus.listen(RESTORE_SCROLL, this.restoreScrollPosition);
      this.$eventBus.listen(RESET_SCROLL, this.resetScrollPosition);
    }

    beforeDestroy() {
      this.$eventBus.remove(SAVE_SCROLL);
      this.$eventBus.remove(RESTORE_SCROLL);
      this.$eventBus.remove(RESET_SCROLL);
    }

    saveScrollPosition() {
      this.previousScrollPosition = this.container.scrollTop;
    }
    
    restoreScrollPosition() {
      this.container.scrollTop = this.previousScrollPosition;
    }

    resetScrollPosition() {
      this.previousScrollPosition = 0;
      this.container.scrollTop = 0;
    }
  }
